
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.333 2.5h-5a.833.833 0 00-.833.833v5a.833.833 0 00.833.834h5a.833.833 0 00.834-.834v-5a.833.833 0 00-.834-.833zm-.833 5H4.167V4.167H7.5V7.5zm9.167 3.333h-5a.833.833 0 00-.834.834v5a.833.833 0 00.834.833h5a.833.833 0 00.833-.833v-5a.833.833 0 00-.833-.834zm-.834 5H12.5V12.5h3.333v3.333zM14.167 2.5a3.337 3.337 0 00-3.334 3.333 3.337 3.337 0 003.334 3.334A3.337 3.337 0 0017.5 5.833 3.337 3.337 0 0014.167 2.5zm0 5c-.92 0-1.667-.747-1.667-1.667 0-.919.748-1.666 1.667-1.666s1.666.747 1.666 1.666c0 .92-.747 1.667-1.666 1.667zm-8.334 3.333A3.337 3.337 0 002.5 14.167 3.337 3.337 0 005.833 17.5a3.337 3.337 0 003.334-3.333 3.337 3.337 0 00-3.334-3.334zm0 5c-.919 0-1.666-.747-1.666-1.666 0-.92.747-1.667 1.666-1.667.92 0 1.667.748 1.667 1.667s-.747 1.666-1.667 1.666z"}})])
          )
        }
      }
    